import styled from "styled-components";

// Common Filter Button Style
export const FilterButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.active ? "#667eea" : "#4a5568")};
  font-size: 0.85rem;
  transition: all 0.2s;
  min-width: 24px;
  height: 24px;
  flex-shrink: 0;

  &:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.1);
    border-radius: 4px;
  }

  svg {
    width: 14px;
    height: 14px;
  }

  svg:first-child {
    margin: 0;
  }

  svg:last-child {
    margin-left: 2px;
    width: 10px;
    height: 10px;
  }
`;

// Common Filter Dropdown Style
export const FilterDropdown = styled.div`
  position: fixed;
  top: ${(props) =>
    props.top !== undefined && props.top !== null ? `${props.top}px` : "auto"};
  right: ${(props) =>
    props.alignRight && props.right !== undefined && props.right !== null
      ? `${props.right}px`
      : "auto"};
  left: ${(props) =>
    !props.alignRight && props.left !== undefined && props.left !== null
      ? `${props.left}px`
      : "auto"};
  background: ${props => props.isDarkMode ? '#2d3748' : 'white'};
  border: 1px solid ${props => props.isDarkMode ? '#4a5568' : '#e1e5ee'};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, ${props => props.isDarkMode ? '0.4' : '0.2'});
  z-index: 9999;
  min-width: 280px;
  max-width: 320px;
  padding: 1rem;
  margin-top: 4px;
  transition: background 0.3s ease, border-color 0.3s ease;

  /* Ensure dropdown doesn't overflow viewport - CSS fallback */
  ${(props) =>
    !props.alignRight &&
      props.fieldName === "streetViewCompletionDate" &&
      props.left
      ? `
        max-width: min(320px, calc(100vw - ${props.left}px - 16px));
      `
      : ""}

  /* Ensure dropdown doesn't overflow viewport */
  @media (max-width: 768px) {
    right: ${(props) =>
    props.right !== undefined && props.right !== null
      ? `${props.right}px`
      : "1rem"};
    left: auto;
    min-width: 260px;
    max-width: calc(100vw - 2rem);
  }
`;

// Common Filter Actions Style
export const FilterActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

// Common Filter Button Styled
export const FilterButtonStyled = styled.button`
  flex: 1;
  padding: 0.5rem;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &.apply {
    background: linear-gradient(90deg, #667eea, #764ba2);
    color: white;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(102, 126, 234, 0.3);
    }

    &:disabled {
      background: ${props => props.isDarkMode ? '#4a5568' : '#ccc'};
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }

  &.clear {
    background: ${props => props.isDarkMode ? '#4a5568' : '#f8f9fd'};
    color: ${props => props.isDarkMode ? '#e2e8f0' : '#4a5568'};
    border: ${props => props.isDarkMode ? 'none' : '1px solid #e1e5ee'};

    &:hover {
      background: ${props => props.isDarkMode ? '#2d3748' : '#e1e5ee'};
    }
  }
`;

// Common Filter Label Style
export const FilterLabel = styled.label`
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: ${props => props.isDarkMode ? '#cbd5e0' : '#4a5568'};
  margin-bottom: 0.5rem;
  transition: color 0.3s ease;
`;

// Common Filter Container Style
export const FilterContainer = styled.div`
  position: relative;
  display: inline-block;
`;

// Common Filter Type Select Style
export const FilterTypeSelect = styled.select`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid ${props => props.isDarkMode ? '#4a5568' : '#e1e5ee'};
  border-radius: 6px;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  cursor: pointer;
  background-color: ${props => props.isDarkMode ? '#1a202c' : 'white'};
  color: ${props => props.isDarkMode ? '#e2e8f0' : '#333'};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
  }
`;

// Common Date Input Style
export const DateInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid ${props => props.isDarkMode ? '#4a5568' : '#e1e5ee'};
  border-radius: 6px;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  background-color: ${props => props.isDarkMode ? '#1a202c' : 'white'};
  color: ${props => props.isDarkMode ? '#e2e8f0' : '#333'};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  /* Style color scheme for dark mode */
  color-scheme: ${props => props.isDarkMode ? 'dark' : 'light'};
`;
